import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { FETCH_PROJECTS_REQUEST } from "../store/Actions/Actions";
import { PROJECT_DETAILS } from "../config/API_Collection";
import { formatCurrency } from "../utils/format";

export const ClientProjects = (props) => {
  const isLoading = useSelector((_) => _?.project?.isLoading);
  const projects = useSelector((_) => _?.project?.projects);
  //   const [isLoading, setIsLoading] = useState(true);
  // const [projects, setProjects] = useState([]);
  const [toast, setToast] = useState({ message: "", type: "" });

  //const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const projectsPerPage = 5;
  const [checkUpdate, setCheckUpdate] = useState(true);

  const navigate = useNavigate();
  const DISPATCH = useDispatch();

  //   const [isLoading, setIsLoading] = useState(true);
  // const [projects, setProjects] = useState([]);

  const projectDetail = (projectId) => {
    navigate(`${PROJECT_DETAILS}${projectId}`);
  };

  const filteredProjects = projects?.filter((project) =>
    project.project_name?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const indexOfLast = currentPage * projectsPerPage;
  const indexOfFirst = indexOfLast - projectsPerPage;
  const currentProjects = filteredProjects.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(filteredProjects.length / projectsPerPage);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) setCurrentPage(page);
  };


  const showToast = (message, type) => {
    setToast({ message, type });
  };

  useEffect(() => {
    // fetchProjects();
    DISPATCH({ type: FETCH_PROJECTS_REQUEST,payload:{empid:props?.empid} });
  }, [checkUpdate]);

  return (
    <div className="">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <input
          type="text"
          className="form-control w-25"
          placeholder="Filter by project name..."
          value={searchTerm}
          onChange={(e) => {
            setSearchTerm(e.target.value);
            setCurrentPage(1);
          }}
        />
        {/* <button className="btn btn-primary d-flex align-items-center">
          <i className="bi bi-plus-circle me-1"></i> Add Project
        </button> */}
      </div>

      {isLoading ? (
        <div className="loading-wrapper">
          <div class="spinner-border text-secondary" role="status"></div>
        </div>
      ) : (
        <>
          <div className="table-responsive">
            <table className="table table-bordered custom-table">
              <thead>
                <tr>
                  <th>Project ID</th>
                  <th>Project</th>
                  <th>Client</th>
                  <th>Project Manager</th>
                  <th>Budget ($)</th>
                  <th>Start Date</th>
                  <th>End Date</th>
                  {/* <th></th> */}
                </tr>
              </thead>
              <tbody>
                {currentProjects.length > 0 ? (
                  currentProjects.map((project) => (
                    <tr
                      key={project.pid}
                      onClick={() => projectDetail(project.pid)}
                      style={{ cursor: "pointer" }}
                    >
                      <td>{project.project_code}</td>
                      <td>{project.project_name}</td>
                      <td>{project.client}</td>
                      <td>
                        {project.project_manager_first_name}{" "}
                        {project.project_manager_last_name}
                      </td>
                      <td>{formatCurrency(project.budget)}</td>
                      <td>{project?.start_date ?? "--"}</td>
                      <td>{project?.end_date || "--"}</td>
                      {/* <td><i class="bi bi-circle-fill text-success "></i></td> */}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="8" className="text-center">
                      No projects available
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination controls */}
          <div className="pagination-controls d-flex justify-content-center mt-3">
            <button
              className="btn btn-outline-primary mx-1"
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
            >
              Prev
            </button>
            {[...Array(totalPages)].map((_, i) => (
              <button
                key={i}
                className={`btn mx-1 ${
                  currentPage === i + 1 ? "btn-primary" : "btn-outline-primary"
                }`}
                onClick={() => handlePageChange(i + 1)}
              >
                {i + 1}
              </button>
            ))}
            <button
              className="btn btn-outline-primary mx-1"
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
            >
              Next
            </button>
          </div>
        </>
      )}

      {/* Modal for Add Project */}
    </div>
  );
};
